import axios from 'axios'
import { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import { constants } from '../../Constants'
import { PageLoader } from '../SpinnerLoading/SpinnerLoading'

export const ActiveUsersChart = ({ selectedYear }) => {
  const [chartData, setChartData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const response = await axios.get(
          `${constants.urlLocal}getActiveUsersByYear/${selectedYear}`
        )
        setChartData(response.data.monthlyActiveUsers || [])
      } catch (error) {
        console.error('Error al obtener usuarios activos', error)
      }
      setLoading(false)
    }
    fetchData()
  }, [selectedYear])

  const months = [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ]

  const options = {
    chart: { type: 'line', toolbar: { show: false } },
    xaxis: { categories: months },
    colors: ['#28a745'],
    stroke: { curve: 'smooth', width: 3 },
  }

  const series = [{ name: 'Usuarios Activos', data: chartData }]

  if (loading)
    return (
      <div className="flex-center" style={{ height: '200px' }}>
        <PageLoader />
      </div>
    )

  return (
    <div className="card-box">
      <h3 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.5rem' }}>
        Usuarios Activos por Mes
      </h3>
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={300}
      />
    </div>
  )
}
